// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import NocPhotosActionType from './noc-photos.types';

const INITIAL_STATE = {
	updateNocPhotosResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** update Noc Photos Start ************************/
		case NocPhotosActionType.UPDATE_NOC_PHOTOS_SUCCESS:
			return { ...state, updateNocPhotosResponse: action.payload };

		case NocPhotosActionType.UPDATE_NOC_PHOTOS_FAILURE:
			return { ...state, updateNocPhotosResponse: action.payload };

		case NocPhotosActionType.UPDATE_NOC_PHOTOS_RESPONSE_CHANGED:
			return { ...state, updateNocPhotosResponse: null };

		/** ***************** update Noc Photos End ************************/

		default:
			return state;
	}
};
